
export const ERROR_LOGIN_NEEDED = 'You need to login';
export const ERROR_NOT_FOUND = 'Not found';
export const ERROR_SOMETHING_GOES_WRONG = 'Something goes wrong';

export const OK_CREATED = 'Created';

